var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"vessel-image",attrs:{"id":"image-loading","src":_vm.image,"text":_vm.avatarText}})
}
var staticRenderFns = []

export { render, staticRenderFns }